<template>
  <el-card  id="confManageTemp">
    <!--条件查询-->
    <div class="search-form">
      <el-form inline :model="originData" ref="searchForm">
        <el-form-item label="更新时间" prop="updateTimeStart">
          <el-date-picker type="date" v-model="originData.updateTimeStart" placeholder="起始日期"/>
          <span style="margin:auto 10px;color:#999999">至</span>
          <el-date-picker type="date" v-model="originData.updateTimeEnd" placeholder="结束日期"/>
        </el-form-item>
        <el-form-item label="模块名称" prop="moduleName">
          <el-input placeholder="请输入模块名称" onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model.trim="originData.moduleName"/>
        </el-form-item>
        <el-form-item label="模块标识" prop="moduleIdentif">
          <el-input placeholder="请输入模块标识" onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model.trim="originData.moduleIdentif"/>
        </el-form-item>
      </el-form>
    </div>
    <div class="flex">
      <div>
        <el-button
          size="small"
          type="primary"
          @click="search"
        >查询</el-button>
        <el-button
          size="small"
          @click="reset"
        >重置</el-button>
      </div>
      <div>
        <yh-button
          size="small"
          @click='addDialogCtrl()'
          v-if="judgeJurisdiction('412821822246965248')"
        >新增模块</yh-button>
      </div>
    </div>
    <!--提示信息列表-->
    <el-row>
      <el-table
        :data="tableData"
        style="width: 100%">
        <template slot="empty">
          {{emptyText}}
        </template>
        <el-table-column
          v-for="item in tableColumnData"
          :key="item.prop"
          :prop="item.prop"
          :width="item.width"
          :label="item.label"
          align="center">
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          width="100"
          align="center">
          <template slot-scope="scope">
            <span
              class="button--blue"
              @click="editDialogCtrl(scope.row)"
              type="primary"
              v-if="judgeJurisdiction('412821959367151616')"
            >修改</span>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <!--分页-->
    <el-row style="text-align:center">
      <yh-pagination
      :page.sync="currentPage"
      :total="sumCount"
      />
    </el-row>
    <!--新增提示信息模态框-->
    <yh-dialog title="新增模块" :visible.sync="addDialogVisible">
      <el-form
        :model="addModuleData"
        class="hide-error"
      >
        <el-form-item label="模块名称" prop="moduleName" required>
          <el-input v-model="addModuleData.moduleName" placeholder="请输入提示信息名称，不超过20字" maxlength="20"/>
        </el-form-item>
        <el-form-item label="模块标识" prop="moduleIdentif" required>
          <el-input v-model="addModuleData.moduleIdentif" placeholder="请输入提示信息标识，不超过40字" maxlength="40"/>
        </el-form-item>
        <el-form-item label="模块说明" prop="moduleName">
          <el-input type="textarea" v-model="addModuleData.moduleComment"  :autosize="{ minRows: 5}" placeholder="请输入提示信息说明，不超过200字" maxlength="200"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="addLoadFlag" @click="addModuleDetail();">提交</el-button>
      </span>
    </yh-dialog>
    <!--修改提示信息模态框-->
    <yh-dialog title="修改模块" :visible.sync="editDialogVisible">
      <el-form
        :model="editModuleData"
        class="hide-error"
      >
        <el-form-item label="模块名称" prop="moduleName" required>
          <el-input v-model="editModuleData.moduleName" disabled/>
        </el-form-item>
        <el-form-item label="模块标识" prop="moduleIdentif" required>
          <el-input v-model="editModuleData.moduleIdentif" disabled/>
        </el-form-item>
        <el-form-item label="模块说明" prop="moduleName">
          <el-input type="textarea" v-model="editModuleData.moduleComment"  :autosize="{ minRows: 3}" placeholder="请输入提示信息说明，不超过200字" maxlength="200"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="editDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="editLoadFlag" @click="editParamDetail();">提交</el-button>
      </span>
    </yh-dialog>
  </el-card>
</template>
<script>
import { getFunctionList, addNav, getPagingData } from '@/mixins';

export default {
  mixins: [getFunctionList, getPagingData],
  data() {
    return {
      functionList: [],
      emptyText: this.$LS.empty,
      errorCode: 'E00000',
      // 条件查询
      originData: {
        updateTimeEnd: '',
        updateTimeStart: '',
        moduleIdentif: '',
        moduleName: '',
      },
      searchParam: {
        updateTimeEnd: '',
        updateTimeStart: '',
        moduleIdentif: '',
        moduleName: '',
      },
      // 新增数据集
      addModuleData: {
        moduleIdentif: '',
        moduleName: '',
        moduleComment: '',
      },
      // 修改数据集
      editModuleData: {
        id: '',
        moduleIdentif: '',
        moduleName: '',
        moduleComment: '',
      },
      // 列名
      tableColumnData: [
        {
          label: '模块ID',
          prop: 'id',
        },
        {
          label: '模块标识',
          prop: 'moduleIdentif',
        }, {
          label: '模块名称',
          prop: 'moduleName',
        }, {
          label: '模块说明',
          prop: 'moduleComment',
        }, {
          label: '更新时间',
          prop: 'updateTime',
        }, {
          label: '更新人ID',
          prop: 'updateUser',
        },
      ],
      // 提示信息列表
      tableData: [],
      // 当前页码
      currentPage: 1,
      pageSize: 10,
      pageNo: 1,
      // 数据量
      sumCount: 0,
      // 新增模态框可见标记
      addDialogVisible: false,
      // 修改模态框可见标记
      editDialogVisible: false,
      addLoadFlag: false,
      editLoadFlag: false,
    };
  },
  watch: {
    // 分页查询
    currentPage: {
      immediate: true,
      handler() {
        this.getTableData(true);
      },
    },
  },
  mounted() {
    const token = this.$route.query.userToken;
    const sessionData = JSON.parse(this.$route.query.sessionData);
    sessionStorage.setItem('userToken', JSON.stringify(token));
    sessionStorage.setItem('sessionData', JSON.stringify(sessionData));
    this.getJurisdiction();
  },
  methods: {
    // 获取功能权限
    getJurisdiction() {
      const params = {
        data: {
          roleId: JSON.parse(sessionStorage.getItem('sessionData')).roleId,
          userId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          token: JSON.parse(sessionStorage.getItem('userToken')),
        },
      };
      this.$_post(this.$API.get_role_menu, params).then((res) => {
        console.log(res);
        this.functionList = res.data.roleMenuList;
      }).catch((error) => {
        console.log(error);
      });
    },
    // 判断是否有权限
    judgeJurisdiction(v) {
      for (let index = 0; index < this.functionList.length; index++) {
        if (this.functionList[index].menuId === v) {
          return true;
        }
      }
      return false;
    },
    // 重置条件查询
    reset() {
      Object.keys(this.originData).forEach((key) => {
        this.originData[key] = '';
        this.searchParam[key] = '';
      });
    },
    search() {
      this.searchParam = { ...this.originData };
      this.currentPage = 1;
      this.pageNo = 1;
      this.getTableData();
    },
    // 模块信息查询
    getTableData(emptyValue) {
      this.getPagingData(this.$API.getModuleListPage, emptyValue);
    },
    // 新增模块信息
    addModuleDetail() {
      // 非空判断
      if (this.addModuleData.moduleName === '') {
        this.$message({
          message: '请输入模块名称',
          type: 'warning',
          showClose: true,
        });
        return;
      }
      if (this.addModuleData.moduleIdentif === '') {
        this.$message({
          message: '请输入模块标识',
          type: 'warning',
          showClose: true,
        });
        return;
      }
      this.addLoadFlag = true;
      this.$_yh_confirm('模块新增后将无法删除，确定要新增吗？', '新增模块').then(() => {
        const params = {
          data: {
            moduleName: this.addModuleData.moduleName,
            moduleIdentif: this.addModuleData.moduleIdentif,
            moduleComment: this.addModuleData.moduleComment,
            updateUser: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            createUser: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          },
        };
        this.$_post(this.$API.addModuleDetail, params).then((res) => {
          if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
            this.addDialogVisible = false;
            this.getTableData();
          } else {
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          }
        }).catch((error) => {
          console.log(error);
        });
        this.addLoadFlag = false;
      }).catch(() => {
        this.addLoadFlag = false;
      });
    },
    // 编辑模块信息
    editParamDetail() {
      this.editLoadFlag = true;
      this.$_yh_confirm(`确认要修改"${this.editModuleData.moduleIdentif}"的模块信息吗？`, '修改模块').then(() => {
        const params = {
          data: {
            id: this.editModuleData.id,
            moduleComment: this.editModuleData.moduleComment,
            updateUser: JSON.parse(sessionStorage.getItem('sessionData')).userId,
            uId: JSON.parse(sessionStorage.getItem('sessionData')).userId,
          },
        };
        this.$_post(this.$API.editModuleDetail, params).then((res) => {
          if (res.errorCode === this.errorCode) {
            this.$message({
              message: '成功',
              type: 'success',
              showClose: true,
            });
            this.editLoadFlag = false;
            this.editDialogVisible = false;
            this.getTableData();
          } else {
            this.$message({
              message: res.errorMsg,
              type: 'error',
              showClose: true,
            });
          }
        }).catch((error) => {
          console.log(error);
        });
        this.editLoadFlag = false;
      }).catch(() => {
        this.editLoadFlag = false;
      });
    },
    // 新增模态框控制器
    addDialogCtrl() {
      // 清理历史新增数据
      this.addModuleData.moduleName = '';
      this.addModuleData.moduleIdentif = '';
      this.addModuleData.moduleComment = '';
      // 打开新增模态框
      this.addDialogVisible = true;
    },
    // 编辑模态框控制器
    editDialogCtrl(row) {
      this.editModuleData.id = row.id;
      this.editModuleData.moduleName = row.moduleName;
      this.editModuleData.moduleIdentif = row.moduleIdentif;
      this.editModuleData.moduleComment = row.moduleComment;
      // 打开编辑模态框
      this.editDialogVisible = true;
    },
  },
};
</script>
<style lang="scss" scoped>
#confManageTemp {

  overflow: initial;
  .search-col {
    display: flex;
  }
  .search-col-div {
    display: table;
    line-height: 27px;
  }
  .editKey {
    text-align: right;
  }
  .saveSort {
    color: #5CCBFA;
  }
  .saveSort:hover {
    cursor: pointer;
    color: #92D9F7;
  }
  .flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;
  }
}
</style>
